module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "share-button"
  }, [_c('button', {
    class: _vm.$i18n.locale() == 'ar' ? 'btn btn-success btn-xs pull-left' : 'btn btn-success btn-xs pull-right',
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$store.commit('setShowShare', true)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Share')))])]), _vm._v(" "), _c('h1', {
    staticClass: "page-top-title"
  }, [_vm._v(_vm._s(_vm.$t('Transactions')))]), _vm._v(" "), _c('label', {
    staticClass: "label label-warning"
  }, [_vm._v(_vm._s(_vm.$t('Page is under-construction')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "transacion-date-filters"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "startDate-addon"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('Start date')) + " ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "date",
      "type": "date",
      "aria-describedby": "startDate-addon"
    },
    domProps: {
      "value": _vm.startDate
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "endDate-addon"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('End date')) + " ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "date",
      "type": "date",
      "aria-describedby": "endDate-addon"
    },
    domProps: {
      "value": _vm.endDate
    }
  })])]), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v(_vm._s(_vm.$t('Transactions')))]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('Charity')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Amount')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.$store.getters.getTransactions), function(item) {
    return _c('tr', [_c('td', [_vm._v("\n              " + _vm._s(item.association.name)), _c('hr'), _vm._v("\n              " + _vm._s(item.date) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatEuros(item.amount)) + " €")])])
  }))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5253c522"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Transactions.vue
// module id = 307
// module chunks = 1